import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { STATE_TO_ICON as d, STATE_TO_TEXT_COLOR as c } from "./index.es5488.js";
import a from "./index.es5489.js";
import { TinyText as m } from "./index.es493.js";
const p = ({ message: i, state: e, hideIcon: s = !1, testId: o }) => /* @__PURE__ */ t(
  "div",
  {
    className: a.container,
    "aria-label": `feedback ${e}`,
    "data-testid": o,
    role: "status",
    "data-identifier": "feedback-message",
    children: [
      !s && /* @__PURE__ */ r("div", { className: a.iconWrapper, children: d[e] }),
      /* @__PURE__ */ r(m, { variant: "address", color: c[e], children: i })
    ]
  }
);
export {
  p as FeedbackMessageItem
};
//# sourceMappingURL=index.es718.js.map
